import * as React from 'react';

const SvgPinFill = (props) => (React.createElement("svg", Object.assign({ width: 24, height: 24, fill: "none", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.529 14.469C1.926 9.334 4.943 2 11.983 2s10.143 7.451 6.452 12.613c-.371.518-.744 1.05-1.116 1.58C15.255 19.139 13.25 22 11.983 22c-1.268 0-3.287-2.936-5.353-5.94-.367-.533-.735-1.07-1.101-1.591Zm3.994-2.298a3.5 3.5 0 1 1 4.95-4.95 3.5 3.5 0 0 1-4.95 4.95Z", fill: "currentColor" })));

export { SvgPinFill as default };
